import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/customers/customersActions";
import { CustomerEditDialogHeader } from "./CustomerEditDialogHeader";
import { CustomerEditForm } from "./CustomerEditForm";
import { useCustomersUIContext } from "../CustomersUIContext";
import axios from "axios";
import { useSnackbar } from "react-simple-snackbar";

export function CustomerEditDialog({ id, show, onHide }) {
  // Customers UI Context

  const [openSnackbarError] = useSnackbar({
    style: {
      backgroundColor: "red",
      border: "2px solid white",
      color: "white",

      fontSize: "15px",
      textAlign: "center",
    },
  });
  const [openSnackbarSuccess] = useSnackbar({
    style: {
      backgroundColor: "green",
      border: "2px solid white",
      color: "white",

      fontSize: "15px",
      textAlign: "center",
    },
  });

  const customersUIContext = useCustomersUIContext();
  const customersUIProps = useMemo(() => {
    return {
      initCustomer: customersUIContext.initCustomer,
    };
  }, [customersUIContext]);

  // Customers Redux state
  const dispatch = useDispatch();
  const { actionsLoading, customerForEdit } = useSelector(
    (state) => ({
      actionsLoading: state.customers.actionsLoading,
      customerForEdit: state.customers.customerForEdit,
    }),
    shallowEqual
  );

  useEffect(() => {
    // server call for getting Customer by id
    dispatch(actions.fetchCustomer(id));
  }, [id, dispatch]);

  // server request for saving customer
  const saveCustomer = (customer) => {
    if (!id) {
      axios
        .post(process.env.REACT_APP_API_BASE_URL + "customer", customer)
        .then((data) => {
          openSnackbarSuccess("Added");
          // dispatch(actions.fetchCustomers(customersUIProps.queryParams));
          dispatch(actions.fetchCustomers(customersUIProps.queryParams));
          // clear selections list
          // closing update modal
          //  onHide();
        })
        .catch((error) => {
          openSnackbarError(error.response.data.error);
        });
      // server request for creating customer
      //  dispatch(actions.createCustomer(customer)).then(() => onHide());
    } else {
      axios
        .put(`${process.env.REACT_APP_API_BASE_URL}customer/${customer._id}`, {
          customer,
        })
        .then((data) => {
          openSnackbarSuccess("Updated");
          // dispatch(actions.fetchCustomers(customersUIProps.queryParams));
          dispatch(actions.fetchCustomers(customersUIProps.queryParams));
          // clear selections list
          // closing update modal
          onHide();
        })
        .catch((error) => {
          openSnackbarError(error.response.data.error);
        });

      // // server request for updating customer
      //   dispatch(actions.updateCustomer(customer)).then(() => {
      //   // refresh list after deletion
      //   dispatch(actions.fetchCustomers(customersUIProps.queryParams));
      //   // clear selections list

      //   // closing update modal
      //   onHide();
      // });
    }
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <CustomerEditDialogHeader id={id} />
      <CustomerEditForm
        saveCustomer={saveCustomer}
        actionsLoading={actionsLoading}
        customer={customerForEdit || customersUIProps.initCustomer}
        onHide={onHide}
      />
    </Modal>
  );
}
